export default __webpack_public_path__ + "static/media/iform_bagsh.fb22022b.jpeg";